import { useId } from 'react';
import { SVGProps } from '../types';

export const SystemFolderOpenIcon = (props: SVGProps) => {
  const reactId = useId();
  const maskId = `mask-${reactId}`;
  const g0 = `g0-${reactId}`;
  const g1 = `g1-${reactId}`;
  const g2 = `g2-${reactId}`;

  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      {/* Source artwork is 18×16; scaled to fit a 16×16 viewBox while
          preserving aspect ratio (vertical centering). */}
      <g transform="translate(0, 0.889) scale(0.8889)">
        <path
          d="M5.03193 1C6.26212 1.00008 7.43288 2.33359 8.66309 2.33359H11.4785C12.9393 2.33359 13.6696 2.33363 14.2276 2.62422C14.7184 2.87984 15.1177 3.2874 15.3679 3.78906C15.6522 4.3595 15.6522 5.10653 15.6522 6.6V10.2C15.6522 11.8801 15.6518 12.72 15.3319 13.3617C15.0506 13.9262 14.6018 14.385 14.0495 14.6726C13.4217 14.9996 12.6001 15 10.9565 15H4.17366C2.71298 15 1.98257 14.9999 1.42459 14.7094C0.933738 14.4537 0.534411 14.0455 0.284307 13.5438C8.64837e-05 12.9734 9.63516e-10 12.2267 0 10.7336V3.66641C0.000137921 2.19386 1.1679 1.00014 2.60844 1H5.03193Z"
          fill="#027ED4"
        />
        <mask
          id={maskId}
          style={{ maskType: 'luminance' }}
          maskUnits="userSpaceOnUse"
          x="0"
          y="1"
          width="16"
          height="14"
        >
          <path
            d="M5.03193 1C6.26212 1.00008 7.43288 2.33359 8.66309 2.33359H11.4785C12.9393 2.33359 13.6696 2.33363 14.2276 2.62422C14.7184 2.87984 15.1177 3.2874 15.3679 3.78906C15.6522 4.3595 15.6522 5.10653 15.6522 6.6V10.2C15.6522 11.8801 15.6518 12.72 15.3319 13.3617C15.0506 13.9262 14.6018 14.385 14.0495 14.6726C13.4217 14.9996 12.6001 15 10.9565 15H4.17366C2.71298 15 1.98257 14.9999 1.42459 14.7094C0.933738 14.4537 0.534411 14.0455 0.284307 13.5438C8.64837e-05 12.9734 9.63516e-10 12.2267 0 10.7336V3.66641C0.000137921 2.19386 1.1679 1.00014 2.60844 1H5.03193Z"
            fill="white"
          />
        </mask>
        <g mask={`url(#${maskId})`}>
          <path
            d="M8.663 2.33361V2.66695H11.4784V2.33361V2.00028H8.663V2.33361ZM11.4784 2.33361V2.66695C12.2142 2.66695 12.7464 2.66721 13.165 2.70218C13.5797 2.73683 13.8541 2.80388 14.0794 2.92125L14.2275 2.62424L14.3756 2.32724C14.043 2.15402 13.6732 2.07575 13.2181 2.03773C12.7668 2.00003 12.2034 2.00028 11.4784 2.00028V2.33361ZM14.2275 2.62424L14.0794 2.92125C14.5091 3.14501 14.8585 3.50166 15.0773 3.94044L15.3678 3.78908L15.6583 3.63776C15.3768 3.07321 14.9275 2.61472 14.3756 2.32724L14.2275 2.62424ZM15.3678 3.78908L15.0773 3.94044C15.1921 4.17082 15.2577 4.4514 15.2915 4.87555C15.3257 5.30357 15.326 5.84778 15.326 6.60002H15.6521H15.9782C15.9782 5.85879 15.9784 5.28274 15.9416 4.82128C15.9044 4.35593 15.8279 3.9778 15.6583 3.63776L15.3678 3.78908ZM15.6521 6.60002H15.326V10.2H15.6521H15.9782V6.60002H15.6521ZM15.6521 10.2H15.326C15.326 11.0455 15.3257 11.6596 15.2869 12.1431C15.2485 12.6227 15.1739 12.9443 15.0413 13.2104L15.3318 13.3617L15.6224 13.5131C15.8096 13.1375 15.8952 12.7183 15.9369 12.1975C15.9784 11.6805 15.9782 11.0346 15.9782 10.2H15.6521ZM15.3318 13.3617L15.0413 13.2104C14.7912 13.7122 14.3922 14.12 13.9014 14.3757L14.0494 14.6727L14.1975 14.9697C14.811 14.6501 15.3098 14.1403 15.6224 13.5131L15.3318 13.3617ZM14.0494 14.6727L13.9014 14.3757C13.6411 14.5112 13.3264 14.5875 12.8572 14.6267C12.3843 14.6663 11.7836 14.6667 10.9564 14.6667V15V15.3334C11.7729 15.3334 12.4047 15.3335 12.9105 15.2911C13.42 15.2485 13.83 15.1611 14.1975 14.9697L14.0494 14.6727ZM10.9564 15V14.6667H4.17358V15V15.3334H10.9564V15ZM4.17358 15V14.6667C3.43787 14.6667 2.90566 14.6664 2.48709 14.6315C2.07232 14.5967 1.79789 14.5297 1.57251 14.4123L1.42451 14.7094L1.27647 15.0064C1.60907 15.1796 1.97887 15.2579 2.43396 15.2959C2.88526 15.3336 3.44861 15.3334 4.17358 15.3334V15ZM1.42451 14.7094L1.57251 14.4123C1.14301 14.1886 0.793606 13.8315 0.574768 13.3924L0.284222 13.5438L-0.00634035 13.6951C0.275027 14.2596 0.724253 14.7187 1.27647 15.0064L1.42451 14.7094ZM0.284222 13.5438L0.574768 13.3924C0.459966 13.162 0.39439 12.8815 0.360489 12.4575C0.326277 12.0297 0.326003 11.4857 0.326003 10.7336H-8.46088e-05H-0.326172C-0.326172 11.4747 -0.326403 12.0506 -0.289517 12.5119C-0.252319 12.9771 -0.175758 13.3551 -0.00634035 13.6951L0.284222 13.5438ZM-8.46088e-05 10.7336H0.326003V3.66643H-8.46088e-05L-0.326172 3.6664V10.7336H-8.46088e-05ZM-8.46088e-05 3.66643H0.326003C0.326123 2.37794 1.34791 1.33348 2.60839 1.33336L2.60836 1.00002V0.666687C0.987747 0.666845 -0.326016 2.00977 -0.326172 3.6664L-8.46088e-05 3.66643ZM2.60836 1.00002L2.60839 1.33336H5.03185V1.00002L5.03186 0.666687H2.60836V1.00002ZM5.03185 1.00002V1.33336C5.54806 1.33339 6.07154 1.61526 6.69174 1.95973C7.27203 2.28204 7.94903 2.66695 8.663 2.66695V2.33361V2.00028C8.14679 2.00028 7.62329 1.71843 7.0031 1.37396C6.42282 1.05165 5.74584 0.666732 5.03186 0.666687L5.03185 1.00002Z"
            fill={`url(#${g0})`}
          />
        </g>
        <path
          d="M5.7121 4.49976H12.6914C13.7113 4.49976 14.4652 4.49992 15.0461 4.55366C15.6264 4.60737 16.0116 4.71384 16.3041 4.90991C16.8383 5.26815 17.2148 5.82585 17.3519 6.46382C17.4269 6.81296 17.3864 7.21872 17.2288 7.79194C17.071 8.36593 16.802 9.08633 16.4386 10.0607L15.643 12.1943C15.2689 13.1973 15.0946 13.657 14.8023 13.9935C14.5397 14.2956 14.2097 14.5286 13.8401 14.6716C13.4283 14.831 12.946 14.8334 11.8958 14.8334H4.9165C3.89638 14.8334 3.14189 14.8332 2.56103 14.7795C1.98093 14.7257 1.59546 14.62 1.30305 14.424C0.768846 14.0658 0.393159 13.5079 0.255999 12.8701C0.180941 12.5208 0.221416 12.1146 0.379047 11.5411C0.536836 10.9672 0.805173 10.2467 1.16853 9.27241L1.96414 7.1396C2.33833 6.13628 2.51243 5.67615 2.80482 5.3396C3.06736 5.03744 3.39808 4.80536 3.7678 4.66225C4.17959 4.50288 4.66172 4.49976 5.7121 4.49976Z"
          fill="#027ED4"
          stroke={`url(#${g1})`}
          stroke-width="0.416667"
        />
        <path
          opacity="0.2"
          d="M1.81203 7.08003C2.1815 6.08939 2.36623 5.59407 2.68322 5.22922C2.96325 4.90689 3.31557 4.65877 3.70996 4.50611C4.15638 4.33331 4.67496 4.33331 5.71211 4.33331H12.6913C14.7253 4.33331 15.7423 4.33331 16.3938 4.77016C16.9637 5.15228 17.3648 5.74724 17.511 6.42775C17.6782 7.2057 17.3159 8.1771 16.5913 10.1199L15.7956 12.2533C15.4262 13.2439 15.2415 13.7393 14.9244 14.1041C14.6444 14.4264 14.2921 14.6745 13.8977 14.8272C13.4513 15 12.9327 15 11.8956 15H4.91646C2.88242 15 1.86541 15 1.21386 14.5631C0.643935 14.181 0.242942 13.5861 0.0966808 12.9056C-0.0705261 12.1276 0.291773 11.1562 1.01637 9.21334L1.81203 7.08003Z"
          fill={`url(#${g2})`}
        />
      </g>
      <defs>
        <linearGradient
          id={g0}
          x1="7.826"
          y1="1.00002"
          x2="7.826"
          y2="15"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="white" stop-opacity="0.12" />
          <stop offset="1" stop-color="white" stop-opacity="0" />
        </linearGradient>
        <linearGradient
          id={g1}
          x1="8.80377"
          y1="4.33335"
          x2="8.80377"
          y2="15"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="white" stop-opacity="0.12" />
          <stop offset="1" stop-color="white" stop-opacity="0" />
        </linearGradient>
        <linearGradient
          id={g2}
          x1="-1.14181"
          y1="4.33331"
          x2="9.85725"
          y2="14.581"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="white" />
          <stop offset="1" stop-color="white" stop-opacity="0" />
        </linearGradient>
      </defs>
    </svg>
  );
};
